import React from 'react';
import { connect } from 'react-redux';
import { Tabs } from 'antd';
import { Route } from 'react-router-dom';

import { interfaceActions } from '../../common/redux/actions';
import * as URLs from '../../common/constants/systemUrls';

import './finances.css';
import OrderPayment from './OrderPayment/containers/OrderPayment/OrderPayment';

const { setCaption } = interfaceActions;
const { TabPane } = Tabs;

function getLastPathSegment(path) {
  let segments = path.split('/');
  return segments[segments.length - 1];
}

class Finances extends React.Component {
  componentDidMount() {
    this.props.setCaption({
      enabled: true,
      mainCaption: 'Финансы',
      breadCrumbs: [
        { path: '/' + URLs.CONTROL_PANEL, breadcrumbName: 'Панель управления' },
        { path: '/' + URLs.FINANCES, breadcrumbName: 'Финансы' },
      ],
    });
  }

  onTabsChange = key => {
    let { match, history } = this.props;

    switch (key) {
      case 'order_payment': {
        history.push(match.path + '/order_payment');
        break;
      }
      case 'customer_accounts': {
        history.push(match.path + '/customer_accounts');
        break;
      }
      case 'plan_fact': {
        history.push(match.path + '/plan_fact');
        break;
      }
      case 'accounts_and_services': {
        history.push(match.path + '/accounts_and_services');
        break;
      }
      case 'requests': {
        history.push(match.path + '/requests');
        break;
      }
      default:
        break;
    }
  };

  render() {
    let { location, match } = this.props;
    return (
      <div id="finances" className="basicForm">
        <Tabs
          type="card"
          activeKey={getLastPathSegment(location.pathname)}
          onChange={this.onTabsChange}
        >
          <TabPane tab="Оплата заказов" key="order_payment">
            <Route
              path={match.path + '/order_payment'}
              render={props => <OrderPayment {...props} />}
            />
          </TabPane>
          <TabPane tab="Счета заказчиков" key="customer_accounts">
            <Route />
          </TabPane>
          <TabPane tab="План-факт" key="plan_fact">
            <Route />
          </TabPane>
          <TabPane tab="Счета и услуги" key="accounts_and_services">
            <Route />
          </TabPane>
          <TabPane tab="Запросы на вывод" key="requests">
            <Route />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default connect(state => ({}), {
  setCaption,
})(Finances);
